import { gql } from '@apollo/client';

export const MACHINE_SIMPLE_FIELDS = gql`
    fragment MachineSimpleInfoFields on Machine {
        MachineId
        Name
        SerialNbr
        MachineType {
            MachineTypeId
            Name
        }
    }
`;
